import isString from 'lodash/isString'
import { useCallback } from 'react'

import { Spacing } from '../../../../enums/spacing'
import { Flex } from '../../../Flex'
import { Space } from '../../../Space'
import { Tag } from '../../../Tag'
import { TagsGroup } from '../../../TagsGroup'
import { Text } from '../../../Text'
import { useComboBox } from '../../contexts/comboBoxContext'
import { ComboBoxValue } from '../../types/comboBoxValue'

export interface ComboBoxSelectedItemsProps {
  selectedItemsPrefix?: string
}

export const ComboBoxSelectedItems = ({ selectedItemsPrefix }: ComboBoxSelectedItemsProps) => {
  const { formatDisplayedValue, removeItemFromSelected, selectedItems } = useComboBox()

  const handleRemoveItemClick = useCallback(
    (value: ComboBoxValue) => () => {
      removeItemFromSelected(value)
    },
    [removeItemFromSelected],
  )

  if (!selectedItemsPrefix && !selectedItems.length) {
    return null
  }

  return (
    <>
      <Flex justifyContent="flex-start" gap={Spacing.S6}>
        {selectedItemsPrefix && <Text colorVariant="secondary">{selectedItemsPrefix}</Text>}
        <TagsGroup>
          {selectedItems.map((item, id) => {
            const displayableItemChildren =
              isString(item.children) && formatDisplayedValue !== undefined
                ? formatDisplayedValue(item.children)
                : item.children
            const displayableItemValue = formatDisplayedValue?.(item.value.value) || item.value.value
            const valueToDisplay = displayableItemChildren || displayableItemValue

            return (
              <Tag
                key={`${item.id}-${id}`}
                color={item.isValid ? 'neutral' : 'red'}
                type="subtle"
                onClose={handleRemoveItemClick(item.value.value)}
              >
                {valueToDisplay}
              </Tag>
            )
          })}
        </TagsGroup>
      </Flex>
      <Space size="s8" />
    </>
  )
}
